import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

export const filterTrue =
  () =>
  (obs: Observable<boolean>): Observable<true> =>
    obs.pipe(filter((val): val is true => val));
